import {memo} from "react";
import StrapiImage from "./StrapiImage";
import StaffMember from "../types/StaffMember";
import TextSection from "./cms/TextSection";
import Tag from "./Tag";
import {Heading} from "react-aria-components";
import Image from "next/image";

const CampusStaffDetails: React.FC<StaffMember> = ({
	name,
	biography,
	tags,
	image,
	alternativeImageSrc,
}) => {
	const imageStyleClass = "aspect-square w-56 max-w-full shrink-0 object-cover";
	return (
		<div className="flex max-w-full flex-col items-start gap-6 md:flex-row">
			{image && <StrapiImage image={image.data} className={imageStyleClass} />}
			{!image && alternativeImageSrc && (
				<Image
					alt={`${name}'s headshot`}
					src={alternativeImageSrc}
					width={224}
					height={224}
					className={imageStyleClass}
				/>
			)}
			<div className="flex max-w-full flex-col gap-6">
				<div className="flex flex-col gap-2">
					<Heading level={2}>{name}</Heading>
					<TextSection contents={biography} />
				</div>
				<div className="flex flex-row flex-wrap gap-1">
					{tags &&
						tags.map((tag) => {
							return <Tag key={`staff-tag-${tag.text}`}>{tag.text}</Tag>;
						})}
				</div>
			</div>
		</div>
	);
};

export default memo(CampusStaffDetails);
